import { ZodStorage } from "@apl-digital/zod-storage";
import { z } from "zod";

import { ICartContactInfoSchema } from "@/api/interfaces/cartLayouts";
import { TheatreLayout } from "@/api/interfaces/theatreLayouts";
import { UserLayoutSchema } from "@/api/interfaces/userLayouts";
import { OrdersSchema } from "@/store/orders/types";
import { PaymentCallbackSchema } from "@/store/payment/types";

const logger = process.env.NODE_ENV === "development" ? console : undefined;

export enum StorageKey {
  CART = "CART",
  LANGUAGE = "LANGUAGE",
  ORDERS = "ORDERS",
  USER = "USER",
  CONTACT_INFO = "CONTACT_INFO",
  PRODUCTS_SCROLL = "PRODUCTS_SCROLL",
  LAST_LANDING = "LAST_LANDING",
  SHOPPING_CART_LANGUAGE = "SHOPPING_CART_LANGUAGE",
  PAYMENT_CALLBACK = "PAYMENT_CALLBACK",
}

const StorageSchemas = {
  [StorageKey.CART]: z.string(),
  [StorageKey.LANGUAGE]: z.string(),
  [StorageKey.ORDERS]: OrdersSchema,
  [StorageKey.USER]: UserLayoutSchema,
  [StorageKey.CONTACT_INFO]: ICartContactInfoSchema,
  [StorageKey.PRODUCTS_SCROLL]: z.string(),
  [StorageKey.LAST_LANDING]: z.string(),
  [StorageKey.SHOPPING_CART_LANGUAGE]: z.string(),
  [StorageKey.PAYMENT_CALLBACK]: PaymentCallbackSchema,
} as const;

export const { clearStorage, getStorage, setStorage } = new ZodStorage(
  StorageSchemas,
  { name: "ZodLocalStorage", storage: globalThis.localStorage },
  logger,
);

export enum SessionStorageKey {
  THEATER_RESOURCE = "THEATER_RESOURCE",
  SENTRY_REPLAY_SESSION = "sentryReplaySession", // Managed by sentry
}

const SessionStorageSchemas = {
  [SessionStorageKey.THEATER_RESOURCE]: TheatreLayout,
} as const;

export const {
  clearStorage: clearSessionStorage,
  getStorage: getSessionStorage,
  setStorage: setSessionStorage,
} = new ZodStorage(
  SessionStorageSchemas,
  { name: "ZodSessionStorage", storage: globalThis.sessionStorage },
  logger,
);
